export default __webpack_public_path__ + "static/sett1-a5c25664bc58e9d72f06e37622abd11d.png";